@if (isQualityAnalyst()) {
<app-export-options class="button.menu-item"></app-export-options>
} @if (isAdmin()) {
<button mat-button [matMenuTriggerFor]="menu" class="menu">ADMIN</button>
}
<mat-menu #menu="matMenu">
  <button mat-button class="menu-item" routerLink="/admin/roles">Roles</button>
  <button mat-button class="menu-item" routerLink="/admin/orders-overview">
    Orders
  </button>
  <button mat-button class="menu-item" routerLink="/admin/wcl-admin">
    Web Common Law
  </button>
</mat-menu>
